module.exports = __webpack_public_path__ + "static/media/ht.2ffbb160.jpg";